import moment from "moment";

export enum PageAction {
  ADD,
  EDIT,
  DELETE,
}
export const MAX_PAGE_SIZE = 2147483647;
export const NAVIGATE_ORDER = "/print/orders";
export const CurrentDate = moment().format("YYYY-MM-DD");
export const CurrentDateTime = moment().format("YYYY-MM-DD HH:MM:SS");
export const NoImageFilename = "no-image.png";
export const ShoppingCart = "shoppingCart";

export const REST_URL = process.env.REACT_APP_JJL_REST_URL;
export const SESSION_EXPIRED = "Token Expired";
export const SESSION_EXPIRED_MSG =
  "Session Expired.  You have been logged off the site.";
export const DEFAULT_LANDING_PAGE = "/";

export const LBL_BACK_ORDER_ITEM = "on back order";
export const LBL_SHORT_DATED_ITEM = "short dated item";
export const LBL_ON_REQUEST_ITEM = "on request item";
const SITE_PREFIX =
  process.env.REACT_APP_SITE_ID || window.location.hostname || "unknown";
export const getStorageKey = (key: string): string => `${SITE_PREFIX}_${key}`;

export enum RoleType {
  ADMIN = "Administrators",
  CUSTOMER = "Customers",
  Guest = "Anonymous",
  SUPERADMIN = "SuperUsers",
}
export enum OrderStage {
  PICKING = 0,
  PACKING = 1,
  COMPLETE = 2,
}
export enum StepperOrderStage {
  PICKING = 2,
  PACKING = 3,
  COMPLETE = 4,
}
export const MAX_INTEGER = 2147483647; // Maximum value for a 32-bit signed integer
export const MSG_DEFAULT_DOWNLOAD_TITLE = "File Management";
export const MSG_DEFAULT_ERROR_TITLE = "Application Error";
export const MSG_DEFAULT_NETWORK_ERROR_TITLE = "Connection Error";
export const MSG_DEFAULT_NETWORK_ERROR =
  "Unable to reach the server. Please check your connection or try again later.";
export const MSG_DEFAULT_UPLOAD_TITLE = "File Upload";
export const MSG_DEFAULT_FORM_INVALID =
  "Please check and ensure all mandatory data are present before saving";
export const MSG_DEFAULT_FORM_SUBMIT_TITLE_DELETE = "Record Deletion Request";
export const MSG_DEFAULT_FORM_SUBMIT_TITLE_SAVE = "Record Save Request";
export const MSG_DEFAULT_FORM_SUBMIT_TITLE_UPDATE = "Record Update Request";
export const MSG_DEFAULT_FORM_DATA_LOAD_TITLE = "Retrieving";
export const MSG_DEFAULT_FORM_DATA_LOAD_ERROR =
  "Request failed. Please try again...";
export const MSG_DEFAULT_FORM_SUBMIT_SUCCESS = "Form submitted successfully.";
export const MSG_DEFAULT_FORM_SUBMIT_ERR =
  "Failed to save data.  Please try again...";
export const NOTIFICATION_TITLE_CRINVOICE = "Credit Note";
export const NOTIFICATION_TITLE_JOURNALS = "Journals";
export enum MantineNotificationColor {
  Error = "red",
  Success = "Green",
  Warn = "Amber",
}

export enum MantineNotificationPosition {
  TopLeft = "top-left",
  TopCenter = "top-center",
  TopRight = "top-right",
  BottomLeft = "bottom-left",
  BottomRight = "bottom-right",
}
